// Discover hero copy test: each browser keeps one variant (a third each) so a
// returning visitor sees the same copy. `?hero=a|b|c` pins a variant for review.

export type HeroVariant = "a" | "b" | "c";

export const HERO_VARIANT_STORAGE_KEY = "ato.discovery.hero.variant.v1";

function parse(value: string | null | undefined): HeroVariant | null {
  return value === "a" || value === "b" || value === "c" ? value : null;
}

export function heroVariant(search = typeof window === "undefined" ? "" : window.location.search, random = Math.random): HeroVariant {
  const pinned = parse(new URLSearchParams(search).get("hero"));
  let stored: HeroVariant | null = null;
  try { stored = parse(window.localStorage.getItem(HERO_VARIANT_STORAGE_KEY)); } catch { /* storage unavailable */ }
  const variant = pinned ?? stored ?? (["a", "b", "c"] as const)[Math.min(2, Math.floor(random() * 3))];
  if (variant !== stored) {
    try { window.localStorage.setItem(HERO_VARIANT_STORAGE_KEY, variant); } catch { /* per-load only */ }
  }
  return variant;
}
